<script setup lang="ts">

import HowGiftlyWorksModal from '@consumer/modules/shared/HowGiftlyWorksModal.vue'
import GiftShowcaseModal from '@consumer/modules/recipientGiftLandingV2/staticCardsV2/GiftShowcaseModal.vue'
import { useSharedData } from '@consumer/composables/sharedData'
import { isDesktop } from '@consumer/utils/breakpoints'

const { featureFlags } = $(useSharedData())

const closeWindow = () => {
  if (window.opener != null || window.history.length === 1) {
    window.close()
  }
  else {
    window.location.href = '/'
  }
}
</script>

<template>
  <Head>
    <link rel="canonical" href="https://www.giftly.com/demo">
  </Head>

  <!-- New greeting-card 2.0 Gift Demo (owns its own fullscreen shell + close). -->
  <GiftShowcaseModal
    v-if="featureFlags.newStaticGreetingCardFlow"
    mode="demo"
    @close="closeWindow"
  />

  <HowGiftlyWorksModal
    v-else
    :open="true"
    initialStep="preview-landing"
    @close="closeWindow"
  >
    <template #close-button>
      <div
        class="fixed top-0 right-0 z-2000 flex items-center justify-end gap-6 p-6 pb-4"
        style="height: 77px;"
      >
        <a class="cursor-pointer hover:text-primary-dark text-sm lg:text-base" @click="closeWindow">
          Close
          <span class="hidden lg:inline">Preview</span>
        </a>
        <GButton
          name="buy-a-gift-button"
          primary
          :size="isDesktop ? 'medium' : 'small'"
          class="whitespace-nowrap max-w-max text-sm lg:text-base"
          label="Buy a Gift"
          href="/buy-a-gift"
          :style="{ fontSize: isDesktop ? '17px' : '13px' }"
        />
      </div>
    </template>
  </HowGiftlyWorksModal>
</template>
